import React from 'react';
import { motion } from 'framer-motion';
import { Target, Users, Award } from 'lucide-react';

const About = () => {
  return (
    <div className="sm:mt-8 md:pt-6 lg:pt-8 pt-10">
    <div className="min-h-screen bg-gray-900 py-16 px-4 flex items-center">
      <div className="container mx-auto grid md:grid-cols-2 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          className="space-y-6"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-500 to-cyan-500">
            About Beta Pixel Studio
          </h2>
          <p className="text-gray-300 text-lg leading-relaxed">
            We are a dynamic digital solutions studio passionate about transforming creative visions into stunning digital realities. Our mission is to empower individuals, startups, and medium-sized businesses with professional, affordable, and cutting-edge digital services.
          </p>
          
          <div className="grid md:grid-cols-3 gap-4">
            {[
              { 
                icon: Target, 
                title: 'Our Mission', 
                description: 'Deliver high-quality digital solutions that exceed client expectations' 
              },
              { 
                icon: Users, 
                title: 'Our Clients', 
                description: 'Individuals, startups, and growing businesses' 
              },
              { 
                icon: Award, 
                title: 'Our Promise', 
                description: 'Quality, affordability, and timely delivery' 
              }
            ].map((item, index) => (
              <motion.div
                key={index}
                whileHover={{ scale: 1.05 }}
                className="bg-gray-800/50 p-4 rounded-xl border border-purple-500/30 hover:border-cyan-500/50"
              >
                <item.icon className="text-cyan-500 mb-2" size={40} />
                <h3 className="font-semibold text-white mb-2">{item.title}</h3>
                <p className="text-gray-400 text-sm">{item.description}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          className="bg-gray-800/30 rounded-xl p-6 border border-cyan-500/30"
        >
          <h3 className="text-2xl font-bold text-white mb-4">Why Choose Us?</h3>
          <ul className="space-y-3 text-gray-300">
            {[
              'Affordable Pricing',
              'Quick Turnaround Time',
              'Personalized Service',
              'Modern & Creative Approach',
              'Flexible Solutions',
              'Customer Satisfaction Guaranteed'
            ].map((item, index) => (
              <li key={index} className="flex items-center">
                <span className="w-3 h-3 mr-3 bg-cyan-500 rounded-full"></span>
                {item}
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </div>
    </div>

  );
};

export default About;